// Accès aux services cadastre français (data.gouv.fr / IGN apicarto).

// Récupère la géométrie d'une parcelle à partir de sa référence cadastrale.
export async function fetchParcelGeometry({ code_insee, section, numero }) {
  if (!code_insee || !section || !numero) return null;
  const sec = section.toString().trim().toUpperCase();
  const num = numero.toString().replace(/\D/g, "");
  if (!num) return null;
  const params = new URLSearchParams({
    code_insee: code_insee,
    section: sec.padStart(2, "0"),
    numero: num.padStart(4, "0"),
  });
  const url = `https://apicarto.ign.fr/api/cadastre/parcelle?${params.toString()}`;
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    const geo = await res.json();
    const feature = geo.features && geo.features[0];
    if (!feature) return null;
    return geoJsonToRing(feature.geometry);
  } catch {
    return null;
  }
}

// Géocode un lot de parcelles via le cadastre, avec limitation de concurrence et progression.
export async function geocodeParcels(parcels, onProgress, concurrency = 6) {
  const targets = parcels.filter((p) => p.needsGeometry && p.code_insee && p.section && p.numero);
  let done = 0;
  const total = targets.length;
  if (onProgress) onProgress(0, total);

  let cursor = 0;
  async function worker() {
    while (cursor < targets.length) {
      const p = targets[cursor++];
      const ring = await fetchParcelGeometry(p);
      if (ring) p.polygon = ring;
      p.needsGeometry = false;
      done++;
      if (onProgress) onProgress(done, total);
    }
  }
  await Promise.all(Array.from({ length: Math.min(concurrency, total || 1) }, worker));
  return parcels;
}

// Convertit une géométrie GeoJSON ([lng,lat]) en anneau [[lat,lng],...]
export function geoJsonToRing(geometry) {
  if (!geometry) return null;
  let coords;
  if (geometry.type === "Polygon") coords = geometry.coordinates[0];
  else if (geometry.type === "MultiPolygon") coords = geometry.coordinates[0][0];
  else return null;
  return coords.map(([lng, lat]) => [lat, lng]);
}

// Interroge le cadastre au point cliqué via apicarto IGN.
// Renvoie { properties, ring } de la parcelle cadastrale touchée.
export async function getCadastreInfoAtPoint(latlng) {
  const geom = JSON.stringify({
    type: "Point",
    coordinates: [latlng.lng, latlng.lat],
  });
  const url = `https://apicarto.ign.fr/api/cadastre/parcelle?geom=${encodeURIComponent(
    geom
  )}`;
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    const data = await res.json();
    const feature = data.features && data.features[0];
    if (!feature) return null;
    return { properties: feature.properties, ring: geoJsonToRing(feature.geometry) };
  } catch {
    return null;
  }
}
